import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

import { IModal } from "Pages/Admin/StatusMessages/StatusMessages";
import useFetch from "Hooks/useFetch";
import useAlertContext from "Hooks/useAlertContext";
import { format } from "date-fns";

interface IProps {
    getMessages: (ignore?: boolean) => Promise<void>;
    modal: IModal;
    onSetModal: (modal: IModal) => void;
    selectedRow: any;
    onSetSelectedRow: (row: any) => void;
}

export default function DeleteModal({
    getMessages,
    modal,
    onSetModal,
    selectedRow,
    onSetSelectedRow,
}: IProps) {
    const { deleteRequest } = useFetch();
    const { newAlert } = useAlertContext();

    const deleteMessage = async () => {
        const id = selectedRow.original.id;

        if (!id) {
            console.error("No id found for selected row");
            return;
        }

        const response = await deleteRequest(`/api/admin/system_status/${id}`);

        let data: string | Response;
        try {
            data = await response.json();
        } catch {
            data = response;
        }
        console.log("Delete status message response: ", data);

        if (response.ok) {
            newAlert({ message: "Message deleted", color: "success" });
            getMessages();
        } else {
            newAlert({ message: "Error deleting message", color: "danger" });
        }
        onSetSelectedRow(null);
        onSetModal("");
    };

    return (
        <Modal isOpen={modal === "delete"} toggle={() => onSetModal("")}>
            <ModalHeader toggle={() => onSetModal("")}>
                Delete Status Message
            </ModalHeader>
            {selectedRow && (
                <ModalBody>
                    <p>Are you sure you want to delete this status message?</p>
                    <p>
                        <b>Issued at: </b>
                        {format(
                            new Date(selectedRow.original.issued_at),
                            "MMM dd, HH:mm"
                        )}
                    </p>
                    <p>
                        <b>Type: </b>
                        {selectedRow.original.status_type}
                    </p>
                    <p>
                        <b>Message: </b>
                        {selectedRow.original.status_message}
                    </p>
                    <p>
                        <b>Issued by: </b>
                        {selectedRow.original.issued_by}
                    </p>
                </ModalBody>
            )}
            <ModalFooter>
                <Button color="danger" onClick={deleteMessage}>
                    Delete
                </Button>
            </ModalFooter>
        </Modal>
    );
}
